import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";
import { useParams } from "react-router";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import Swal from "sweetalert2";

const UpdatePeriod = ({ Show, Hide, Title, transferedData, setTransferedData, getStudyDataTransfered }) => {
  const [dateTransfer, setDateTransfer] = useState("");
  const [timeTransfer, setTimeTransfer] = useState("");
  const [period, setPeriod] = useState("");
  const [logoutTime, setLogoutTime] = useState("");
  const [password, setPassword] = useState("");
  let { studyId } = useParams();
  const [showPassword, setShowPassword] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateStudyDatasetTransfer = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Period!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {}
        userData.transferId = transferedData?.transferId
        userData.transferDate = dateTransfer
        userData.transferTime = timeTransfer
        userData.period = period
        userData.timer = logoutTime
        userData.password = password
        userData.studyId = studyId
        userData.mode = StudyMode
        let data = await studyDatasetsServices.updateStudyDatasetTransfer(userData);
        if (data?.statusCode === 200) {
          getStudyDataTransfered();
          setTransferedData("")
          Hide()
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setDateTransfer(transferedData?.transferDate);
    setTimeTransfer(transferedData?.transferTime);
    setPeriod(transferedData?.period);
    setLogoutTime(transferedData?.timer);
    setPassword(transferedData?.password);
  }, [transferedData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Date for transfer{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="date"
              className="fontSize12"
              onChange={(e) => setDateTransfer(e.target.value)}
              value={dateTransfer}
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Time for transfer{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="time"
              className="fontSize12"
              onChange={(e) => setTimeTransfer(e.target.value)}
              value={timeTransfer}
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Period{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter No of Day's"
              className="fontSize12"
              onChange={(e) => {
                const value = e.target.value;
                if (Number(value) < 0) return;
                setPeriod(value);
              }}
              onKeyDown={(e) => {
                if (e.key === "-" || e.key === "e") {
                  e.preventDefault();
                }
              }}
              value={period}
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Logout Time{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="number"
              className="fontSize12"
              placeholder="Enter Logout Time in Minute"
              onChange={(e) => setLogoutTime(e.target.value)}
              value={logoutTime}
            />
          </Form.Group>
          <div className="position-relative">
            <Form.Label className="mb-1 fw-bold">
              Password{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type={showPassword ? "password" : "text"}
              placeholder={`Enter Password`}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            <div
              className="position-absolute CP"
              style={{ top: 27, right: 7, cursor: "pointer" }}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash title="Hide Password" /> : <FaEye title="Reveal Password" />}
            </div>
          </div>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={updateStudyDatasetTransfer}
            disabled={!logoutTime || buttonLoader || !dateTransfer || !timeTransfer || !period || !password}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Updating...
              </div>
            ) : (
              "Update Period"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdatePeriod;
